import { AsyncPipe } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { LoggerCodes, LoggerService } from '@shared/modules/logger/logger';
import { closeSpinner } from '@store/actions/spinner/spinner.actions';
import * as fromRootStore from '@store/index';
import { Go } from '@store/index';
import { selectSpinnerShow } from '@store/selectors/spinner/spinner.selectors';
import { SpinnerModule } from '@vg-constellation/angular-16/spinner';
import { filter, Observable, Subscription, switchMap, timer, withLatestFrom } from 'rxjs';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  standalone: true,
  imports: [AsyncPipe, SpinnerModule],
})
export class SpinnerComponent implements OnInit, OnDestroy {
  subs: Subscription = new Subscription();

  constructor(
    private globalStore: Store<fromRootStore.State>,
    protected loggerService: LoggerService,
  ) {}

  @Input()
  loadingMessage: string;

  show$: Observable<boolean>;

  ngOnInit() {
    this.show$ = this.globalStore.pipe(select(selectSpinnerShow));

    this.subs.add(
      this.show$
        .pipe(
          filter((showSpinner) => showSpinner),
          switchMap(() => {
            return timer(3 * 60000).pipe(
              withLatestFrom(this.show$),
              filter(([, showSpinner]) => showSpinner),
            );
          }),
        )
        .subscribe(() => {
          this.globalStore.dispatch(Go({ path: ['error'] }));
          this.loggerService.error(
            {
              eventId: 'error-page-route-spinner',
              message: 'Spinner active for three minutes due to network problems',
            },
            LoggerCodes.NULL_FAILURE,
          );
        }),
    );
  }

  ngOnDestroy() {
    this.globalStore.dispatch(closeSpinner());
    this.subs.unsubscribe();
  }
}
